import contentHeader from '@/components/generics/content-header/content-header.vue';

export default {
  components: { contentHeader },
  computed: {
    title() {
      return this.url.includes('news.predictit') ? "What's New?" : 'Analysis';
    },
    url() {
      // because atob errors on slug === undefined
      return this.$route.params.slug ? atob(decodeURI(this.$route.params.slug)) : '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/insight/insight-modal/insight-modal.js